import React, { useEffect, useState } from 'react';

export interface VideoImg {
  src?: string;
  title?: string;
}

declare global {
  interface Window {
    iFrameResize?: (options?: any, selector?: string | HTMLElement) => void;
  }
}

export const IframeVideoImage = ({ src, title }: VideoImg) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!src || src.includes("youtube")) return;

    const script = document.createElement("script");
    script.src = "https://skytv.elmotalent.co.nz/js/iframeResizer.min.js";
    script.async = true;
    script.onload = () => {
      if (window.iFrameResize) {
        // Initialize iframeResizer for dynamic resizing based on content
        window.iFrameResize({ checkOrigin: false }, "#elmo-recruitment-embed");
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [src]);

  return (
    <>
      {src && src.includes("youtube") ? (
        <iframe
          className="items-center justify-center w-11/12 md:w-[1000px] md:h-[500px] lg:w-full lg:mx-14 lg:h-[500px] mx-auto"
          src={src}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
      ) : (
        <div
          className="relative w-full"
          style={{
            padding: isMobile ? "0 1rem" : "0 4rem",
          }}
        >
          <iframe
            id="elmo-recruitment-embed"
            className="block w-full border-0"
            // style={{minHeight:'500px'}}
            src={src}
            title={title || "Elmo iframe"}
            data-tabindex="-1"
          ></iframe>
        </div>
      )}
    </>
  );
};

